module.exports = __webpack_public_path__ + "media/images/business/img-wave-5640cd74a22660410ca113065a32aef7.svg";